<a class="header-button" [routerLink]="[routeLink()]">
  <app-icon [name]="icon()" size="xl" />
  <span class="text">
    <ng-content />
  </span>
</a>
